import { LanguageCodeEnum } from "@/lib/enum/language-code.enum";
import { ITemplateContext } from "@/lib/interfaces/template/templateContext.interface";

/** Context document keys that may carry a language field, scanned in priority order; the first key found with a language value is used. New context document types should be added here. */
const CONTEXT_DOCUMENT_KEYS = ["report", "lead", "document", "appointment", "event"] as const;

/**
 * Resolve the default template language.
 * Priority: context document language -> partner language -> ui locale.
 */
export function resolveTemplateLanguage(
  context: ITemplateContext | undefined,
  partnerLanguage: LanguageCodeEnum | undefined,
  uiLocale: LanguageCodeEnum
): LanguageCodeEnum {
  if (context) {
    for (const key of CONTEXT_DOCUMENT_KEYS) {
      const doc = (context as Record<string, unknown>)[key] as { language?: LanguageCodeEnum } | undefined;
      if (doc?.language) {
        return doc.language;
      }
    }
  }
  return partnerLanguage ?? uiLocale;
}
